import { SiJava } from 'react-icons/si'

export const JavaTech = () => {
    return (
        <div>
        <SiJava />
        <h4>Java</h4>
        </div>
    )
}